import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LoginForm from '../components/session/LoginForm';
import { login } from '../actions/sessionActions';
import '../styles/login.scss';
import cbcvLogo from '../assets/logo2016cuadrado_sinfondo.png';

export const LoginPage = ({ login }) => (
  <div id="login">
    <img alt="logo" src={cbcvLogo} />
    <div className="login-wrapper">
      <h4>INGRESA A TU CUENTA</h4>
      <LoginForm onSubmit={user => login(user.toJS())} />
      <div className="forgot-password">
        <Link to="restablecer-contraseña">
          Olvide mi contraseña
        </Link>
      </div>
      <div className="new-account-wrapper">
        <Link to="registro">
          Crear cuenta
        </Link>
      </div>
    </div>
  </div>
);

const { func } = PropTypes;

LoginPage.propTypes = {
  login: func.isRequired
};

const mapDispatch = dispatch => ({
  login: user => dispatch(login(user))
});

export default connect(null, mapDispatch)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js